import { OsConfig } from '../../types/os'

// Port do cálculo do backend (osCalc.ts) para o resumo reativo no front.
// O backend continua sendo a fonte da verdade ao salvar/aprovar.

export interface CalcCfg {
  pisoCache: number
  horasPiso: number
  valorHoraExtra: number
  toleranciaMinutos: number
  kmValor: number
  alimLocal: number
  alimLocalMinExtras: number
  alimViagemDia: number
  divisorLeitor: number
}

export const DEFAULT_CFG: CalcCfg = {
  pisoCache: 250,
  horasPiso: 6,
  valorHoraExtra: 42,
  toleranciaMinutos: 30,
  kmValor: 1.45,
  alimLocal: 60,
  alimLocalMinExtras: 3,
  alimViagemDia: 120,
  divisorLeitor: 400,
}

export const cfgFrom = (c?: OsConfig | null): CalcCfg =>
  c
    ? {
        pisoCache: Number(c.pisoCache),
        horasPiso: c.horasPiso,
        valorHoraExtra: Number(c.valorHoraExtra),
        toleranciaMinutos: c.toleranciaMinutos,
        kmValor: Number(c.kmValor),
        alimLocal: Number(c.alimLocal),
        alimLocalMinExtras: c.alimLocalMinExtras,
        alimViagemDia: Number(c.alimViagemDia),
        divisorLeitor: c.divisorLeitor,
      }
    : DEFAULT_CFG

const r2 = (n: number): number => Math.round((n + Number.EPSILON) * 100) / 100

export const diffMin = (chegada?: string, saida?: string): number => {
  if (!chegada || !saida) return 0
  const m = Math.round((new Date(saida).getTime() - new Date(chegada).getTime()) / 60000)
  return m > 0 ? m : 0
}

export const calcExtras = (min: number, cfg: CalcCfg): number =>
  Math.max(0, Math.floor((min - cfg.horasPiso * 60 + cfg.toleranciaMinutos) / 60))

export const calcCacheTurno = (min: number, cfg: CalcCfg): number =>
  min <= 0 ? 0 : r2(cfg.pisoCache + calcExtras(min, cfg) * cfg.valorHoraExtra)

/** Alimentação LOCAL de UM turno: usa minuto bruto (>= 3h = 180min). Limiar, não cumulativo. */
export const calcAlimLocal = (min: number, cfg: CalcCfg): number =>
  Math.max(0, min - cfg.horasPiso * 60) >= cfg.alimLocalMinExtras * 60 ? cfg.alimLocal : 0

/** Alimentação LOCAL do técnico: soma POR TURNO (cada turno qualificante soma uma cobrança). */
export const calcAlimLocalTotal = (minutosTurnos: number[], cfg: CalcCfg): number =>
  r2(minutosTurnos.reduce((s, min) => s + calcAlimLocal(min, cfg), 0))

export const calcAlimViagem = (dias: number, cfg: CalcCfg): number =>
  r2(Math.max(0, dias) * cfg.alimViagemDia)

export const calcLeitoresSugeridos = (emitidos: number, cfg: CalcCfg): number =>
  emitidos <= 0 ? 0 : Math.ceil(emitidos / cfg.divisorLeitor)
